export default {
    AWD4WD: 'All Wheel Drive / 4 Wheel Drive',
    FWD: 'Front Wheel Drive',
    RWD: 'Rear Wheel Drive',
};
